// removed by extract-text-webpack-plugin
module.exports = {"aside":"_1OxnA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.css
// module id = 574
// module chunks = 0